"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAuthSessionAsync = void 0;
var openAuthSessionAsync_1 = require("./openAuthSessionAsync");
Object.defineProperty(exports, "openAuthSessionAsync", { enumerable: true, get: function () { return openAuthSessionAsync_1.openAuthSessionAsync; } });
